module.exports = __webpack_public_path__ + "img/img3.b1a68423.png";